export const capAllLettersFunc = (string) => {
    return string.toUpperCase();
};